import { memo } from 'react';
import type { NavigateAction, View } from 'react-big-calendar';
import { Button } from '../ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface ICustomToolbarProps {
  label: string;
  onNavigate: (action: NavigateAction) => void;
  onView: (view: View) => void;
  view: View;
}

const CustomToolbar = ({ label, onNavigate, onView, view }: ICustomToolbarProps) => {
  return (
    <div className="flex items-center justify-between p-4 border-b bg-card">
      {/* Navigation buttons */}
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={() => onNavigate('TODAY')}>
          Today
        </Button>
        <Button variant="outline" size="sm" onClick={() => onNavigate('PREV')}>
          <ChevronLeft className="h-4 w-4" />
          Back
        </Button>
        <Button variant="outline" size="sm" onClick={() => onNavigate('NEXT')}>
          Next
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>

      {/* Date label */}
      <h2 className="text-lg font-semibold">{label}</h2>

      {/* View selector */}
      <div className="flex items-center gap-1">
        <Button
          variant={view === 'week' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onView('week' as View)}
        >
          Week
        </Button>
        <Button
          variant={view === 'day' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onView('day' as View)}
        >
          Day
        </Button>
      </div>
    </div>
  );
};

export const CustomToolbarMemo = memo(CustomToolbar);
